import utils from '@/utils'

const LIST_PARAMS_KEY = 'employee:listParams'

export const employee = {
  namespaced: true,
  state: {
    list: {
      data: [],
      meta: {},
    },
    listLoading: false,
    detail: {},
    detailLoading: false,
    deleteLoading: false,
    listParams: JSON.parse(localStorage.getItem(LIST_PARAMS_KEY)),
  },
  getters: {
    list: (state) => {
      return state.list
    },
    detail: (state) => {
      return state.detail
    },
    isListLoading: (state) => {
      return state.listLoading
    },
    isDetailLoading: (state) => {
      return state.detailLoading
    },
    isDeleteLoading: (state) => {
      return state.deleteLoading
    },
    listParams: (state) => {
      return state.listParams
    },
  },
  mutations: {
    setList(state, data) {
      state.list = data
    },
    setDetail(state, data) {
      state.detail = data
    },
    setListLoading(state, data) {
      state.listLoading = data
    },
    setDetailLoading(state, data) {
      state.detailLoading = data
    },
    setDeleteLoading(state, data) {
      state.deleteLoading = data
    },
    setListParams(state, data) {
      localStorage.setItem(LIST_PARAMS_KEY, JSON.stringify(data))
    },
  },
  actions: {
    async getList({ commit, dispatch }, filters) {
      commit('setListLoading', true)
      try {
        const response = await axios.get(`/api/employees`, {
          params: filters,
          paramsSerializer: (params) => utils.toQueryString(params),
        })
        commit('setList', response.data)
      } catch (error) {
        dispatch(
          'handleError',
          { key: 'employee/getList', error },
          { root: true }
        )
      } finally {
        commit('setListLoading', false)
      }
    },
    async getDetail({ commit }, id) {
      commit('setDetailLoading', true)
      const response = await axios.get(`/api/employees/${id}`)
      commit('setDetail', response.data)
      commit('setDetailLoading', false)
    },
    async create({ commit }, data) {
      commit('setDetailLoading', true)
      const response = await axios.post('/api/employees', data)
      commit('setDetail', response.data)
      commit('setDetailLoading', false)
    },
    async update({ commit }, data) {
      commit('setDetailLoading', true)
      const response = await axios.put(`/api/employees/${data.id}`, data)
      commit('setDetail', response.data)
      commit('setDetailLoading', false)
    },
    async delete({ commit }, id) {
      commit('setDeleteLoading', true)
      await axios.delete(`/api/employees/${id}`)
      commit('setDeleteLoading', false)
    },
  },
}
